const ButtonOverrides = {
    styleOverrides: {
        root: {
            fontWeight: 400,
            textTransform: 'none',
        },
    },
};

export { ButtonOverrides };
